export const CHAT_ACTIONS = {
  add: "CHAT/ADD",
  update: "CHAT/UPDATE",
  delete: "CHAT/DELETE",
  reset: "CHAT/RESET"
};
